import React from 'react'
import { Menu, Icon } from 'antd'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup

export const LeadMenu = props => (
  <Menu
    onClick={props.handleClick}
    selectedKeys={[props.currentKey]}
    mode={props.screenWidth > 900 ? 'horizontal' : 'inline'}
  >
    <SubMenu
      title={
        <span>
          <Icon type="profile" />Details
        </span>
      }
    >
      <MenuItemGroup title="Lead Details">
        <Menu.Item key={`/lead/${props.leadId}/attachments`}>Attachments</Menu.Item>
        <Menu.Item key={`/lead/${props.leadId}/followups`}>Follow Ups</Menu.Item>
        <Menu.Item key={`/lead/${props.leadId}/notes`}>Notes</Menu.Item>
      </MenuItemGroup>
    </SubMenu>
    <Menu.Item key={`/lead/${props.leadId}/contacts`}>
      <Icon type="message" />Contacts
    </Menu.Item>
    <Menu.Item key={`/lead/${props.leadId}/estimates`}>
      <Icon type="calculator" />Estimates
    </Menu.Item>
    <Menu.Item key={`/lead/${props.leadId}/proposals`}>
      <Icon type="exception" />Proposals
    </Menu.Item>
    <Menu.Item key={`/lead/${props.leadId}/contracts`}>
      <Icon type="copy" />Contracts
    </Menu.Item>
    <Menu.Item key={`/lead/${props.leadId}/transmittals`}>
      <Icon type="notification" />Transmittals
    </Menu.Item>
    <Menu.Item key={`/lead/${props.leadId}/rfis`}>
      <Icon type="solution" />RFIs
    </Menu.Item>
  </Menu>
)



// WEBPACK FOOTER //
// ./src/pages/lead/components/LeadMenu.component.js